// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_CancelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/anticipations/cancel/{id}
 *
 * Returns the cancellation outcome. Both fields are locally-produced booleans:
 *   - cancelled: always true on the success path (the controller only reaches
 *     sendResponse after the provider cancel + local status update succeed).
 *   - provider_result: the boolean returned by Provider::cancelAnticipation()
 *     (AsaasProvider returns `isset($response['id'])` — a plain bool, not the
 *     raw upstream JSON). Confirms the upstream cancel acknowledged the request.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_CancelResponseDados {
cancelled: boolean
provider_result: boolean
}

export type SubaccountsAnticipations_CancelResponse = ApiResponse<SubaccountsAnticipations_CancelResponseDados>;

registerResponseContract('SubaccountsAnticipations_CancelResponse', {
  cancelled:       { type: 'boolean', required: true },
  provider_result: { type: 'boolean', required: true },
})
